import {
  INSTALL_SERVICES_MANUALLY,
  UPDATE_SERVICE_DETAIL,
} from '@/store/modules/cloud/aws/aws.constants';
import { computed } from 'vue';
import { useStore } from 'vuex';

export function useStoreDataCloud() {
  const store = useStore();

  const fetchAwsServices = (data) =>
    store.dispatch('cloudState/detail/fetchAwsServices', data);

  const fetchAwsServiceInstances = (data) =>
    store.dispatch('cloudState/detail/fetchAwsServiceInstances', data);

  const fetchReadMatricListDataForServices = (data) =>
    store.dispatch(
      'cloudState/detail/fetchReadMatricListDataForServices',
      data,
    );

  const fetchAwsServiceInstancesWithInstanceType = (data) => 
    store.dispatch(
      'cloudState/detail/fetchAwsServiceInstancesWithInstanceType',
      data,
    );

  const fetchReadMatricDataForInstances = (data) =>
    store.dispatch(
      'cloudState/detail/fetchReadMatricDataForInstances',
      data,
    );

  const getTopAlertsPerService = (data) =>
    store.dispatch('cloudState/detail/getTopAlertsPerService', data);

  const installRdsServicesManually = (data) =>
    store.dispatch(`cloudState/aws/${INSTALL_SERVICES_MANUALLY}`, data);

  const updateRdsServicesDetail = (data) =>
    store.dispatch(`cloudState/aws/${UPDATE_SERVICE_DETAIL}`, data);

  const getTopAlertsPerInstances = (data) =>
    store.dispatch('cloudState/detail/getTopAlertsPerInstances', data);

  const fetchLogsData = (data) =>
    store.dispatch('cloudState/detail/fetchLogsData', data);

  const setCurrentPage = (data) =>
    store.commit('cloudState/detail/setCurrentPage', data);

  const setCurrentService = (data) =>
    store.commit('cloudState/detail/setCurrentService', data);

  const setCurrentServices = (data) =>
    store.commit('cloudState/detail/setCurrentServices', data);

  const setClusterLabels = (data) =>
    store.commit('cloudState/detail/setClusterLabels', data);
  const setCurrentServiceInstance = (data) => 
    store.commit('cloudState/detail/setCurrentServiceInstance', data);

  const setShowAddConfigureAlert = (data) => 
    store.commit('alertV2State/configure/setShowAddConfigureAlert', data);

  const setCurrentAlertCapability = (data) => 
    store.commit('alertV2State/configure/setCurrentAlertCapability', data);

  const setCurrentAlertApplication = (data) => 
    store.commit('alertV2State/configure/setCurrentAlertApplication', data);

  const setAlertApplication = (data) => 
    store.commit('alertV2State/configure/setAlertApplication', data);

  const setCurrentSubType = (data) => 
    store.commit('alertV2State/configure/setCurrentSubType', data);

  const setCurrentTab = (data) => 
    store.commit('cloudState/detail/setCurrentTab', data);

  const getCurrentServiceInstances = computed(
    () => store.getters['cloudState/detail/getCurrentServiceInstance'],
  );

  const getCurrentServices = computed(
    () => store.getters['cloudState/detail/getCurrentServices'],
  );

  const getTimeZone = computed(
    () => store.getters['globalState/settings/getTimezone'],
  );

  const getCurrentServiceType = computed(
    () => store.getters['cloudState/services/getCurrentServicesType'],
  );

  const getShowAddConfigureAlert = computed(
    () => store.getters['alertV2State/configure/getShowAddConfigureAlert'],
  );

  const getCurrentService = computed(
    () => store.getters['cloudState/detail/getCurrentService'],
  );

  const getCurrentTab = computed(
    () => store.getters['cloudState/detail/getCurrentTab'],
  );

  return {
    fetchAwsServices,
    fetchAwsServiceInstances,
    fetchReadMatricListDataForServices,
    getTopAlertsPerService,
    getTopAlertsPerInstances,
    setCurrentService,
    setCurrentServices,
    setCurrentServiceInstance,
    setCurrentPage,
    fetchLogsData,
    fetchAwsServiceInstancesWithInstanceType,
    fetchReadMatricDataForInstances,
    getCurrentServiceInstances,
    getShowAddConfigureAlert,
    getCurrentServices,
    getCurrentServiceType,
    getTimeZone,
    setCurrentTab,
    getCurrentTab,
    setShowAddConfigureAlert,
    setCurrentAlertApplication,
    setAlertApplication,
    setCurrentAlertCapability,
    setCurrentSubType,
    getCurrentService,
    installRdsServicesManually,
    updateRdsServicesDetail,
    setClusterLabels
  };
}